import { render, staticRenderFns } from "./JumbotronComponent.vue?vue&type=template&id=752aa8e2&scoped=true"
import script from "./JumbotronComponent.vue?vue&type=script&lang=js"
export * from "./JumbotronComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752aa8e2",
  null
  
)

export default component.exports